import React from 'react';
import Icon from '../../../icons/components/Icon';
import { TOOLBAR_ICON_SIZE, TOOLBAR_LABELED_BUTTON_CLASS } from '../../../../meeting-ui/constants';
/**
 * 全宽底栏 — 图标 + 下方文字标签 的静态展示结构（供 ToolboxItem 复用）。
 *
 * @param {IProps} props - 组件属性。
 * @returns {ReactElement}
 */
export const ToolbarLabeledButtonContent = ({ accessibilityLabel, customClass = '', disabled = false, icon, label, isHangup = false, isScreenShareToggled = false, toggled = false }) => {
    const iconClass = [
        `${TOOLBAR_LABELED_BUTTON_CLASS}-icon`,
        toggled ? 'toggled' : '',
        isScreenShareToggled ? 'screen-share-toggled' : '',
        customClass,
        disabled ? 'disabled' : ''
    ].filter(Boolean).join(' ');
    const labelClass = [
        `${TOOLBAR_LABELED_BUTTON_CLASS}-label`,
        isHangup ? `${TOOLBAR_LABELED_BUTTON_CLASS}-label-hangup` : ''
    ].filter(Boolean).join(' ');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "aria-hidden": 'true', className: iconClass },
            React.createElement(Icon, { size: TOOLBAR_ICON_SIZE, src: icon })),
        React.createElement("span", { "aria-hidden": 'true', className: labelClass, title: accessibilityLabel }, label)));
};
export { TOOLBAR_LABELED_BUTTON_CLASS };
